var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.configResolved)?_c('loader'):(_vm.regionPlan)?_c('region-plans'):_c('customer-plans')
}
var staticRenderFns = []

export { render, staticRenderFns }